var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47 47",
    style: {
      enableBackground: "new 0 0 47 47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,0C10.5,0,0,10.5,0,23.5S10.5,47,23.5,47S47,36.5,47,23.5S36.5,0,23.5,0z M23.5,44C12.2,44,3,34.8,3,23.5 S12.2,3,23.5,3S44,12.2,44,23.5S34.8,44,23.5,44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,23.6l6.7-6.7c0.8-0.8,0.8-2.1,0-2.8c-0.8-0.8-2-0.8-2.8,0l-6.7,6.7l-6.7-6.7c-0.8-0.8-2.1-0.8-2.8,0 c-0.8,0.8-0.8,2,0,2.8l6.7,6.7l-6.7,6.7c-0.8,0.8-0.8,2.1,0,2.8c0.8,0.8,2,0.8,2.8,0l6.7-6.7l6.7,6.7c0.8,0.8,2.1,0.8,2.8,0 c0.8-0.8,0.8-2,0-2.8L26.5,23.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic_close.7608751c7cd058dabaa2fe55d32f5d14.svg";
export { ForwardRef as ReactComponent };